import {ImageType} from '../types/ImageType';

interface UploadedImage {
  readonly imageKey: string;
  readonly contentType: string;
}

export class UploadedImages {
  readonly type: ImageType;
  readonly id: number | string;
  readonly bucket: string;
  /** note, that the order of the specified images is regarded */
  readonly images: UploadedImage[];
  /** optional, the key of the image, that will be used in previews if multiple images are uploaded */
  readonly primaryImage?: string;
}
